"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../_util/utils");
var _jsxRuntime = require("react/jsx-runtime");
const Explain = props => {
  const {
    type = 'error',
    helperText,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    wrapClassName,
    wrapStyle,
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-explain");
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...attrs.data,
    className: wrapClassName,
    style: wrapStyle,
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames.default)(className, baseClassName, type, {
        active: !!helperText
      }),
      style: style,
      children: !!helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: helperText
      })
    })]
  });
};
var _default = exports.default = Explain;